// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1CtYe","colMaxWidth":"Table_colMaxWidth__OmUu-"};